// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-body[data-v-170b643b] {\n  height: 675px;\n}\n.modal-body .default-content[data-v-170b643b] {\n  padding-top: 16px;\n}\n@media only screen and (max-width: 768px) {\n.fs-12[data-v-170b643b] {\n    font-size: 12px;\n}\n}", ""]);
// Exports
module.exports = exports;
